import { useMutation } from '@tanstack/react-query';
import type { BackendTypes } from '@tf/api';
import { TFNotifier } from '@tf/ui';
import { useState } from 'react';
import { type Priority, PrioritySelect } from '@/components/shared/PrioritySelect';
import { setAccountPriorityMutation } from '@/core/mutations';

type AccountPriority = BackendTypes.OverviewImportance;

interface Props {
	accountId: number;
	value: AccountPriority;
}

export const AccountPriorityWidget: React.FC<Props> = ({ value, accountId }) => {
	const [accountPriority, setAccountPriority] = useState<AccountPriority>(value);

	const { mutate } = useMutation({
		mutationFn: (priority: AccountPriority) => {
			return setAccountPriorityMutation({
				accountId,
				priority,
			});
		},
		onSuccess: (isSuccess) => {
			if (isSuccess) {
				TFNotifier.info('Importance has been changed', { id: 'change-importance' });
			}
		},
	});

	const handleChange = (priority: Priority) => {
		const accountPriorityValue = priority as AccountPriority;
		setAccountPriority(accountPriorityValue);
		mutate(accountPriorityValue);
	};

	return <PrioritySelect value={accountPriority as Priority} onChange={handleChange} />;
};
